module.exports = __webpack_public_path__ + "img/ig.42c5b4b7.svg";